export const ru = {
    languages: {
        cs: 'Чешский',
        de: 'Немецкий',
        en: 'Английский',
        es: 'Испанский',
        fr: 'Французский',
        hr: 'Хорватский',
        hu: 'Венгерский',
        it: 'Итальянский',
        nl: 'Голландский',
        pl: 'Польский',
        ru: 'Русский',
        sk: 'Словацкий',
        tr: 'Турецкий',
        uk: 'Украинский',
        undefined: 'Без субтитров',
    },
    player: {
        content: {
            notFound: { title: 'Ошибка при загрузке медиа элемента 😞' },
        },
        controls: {
            backwards: { title: '10с назад' },
            buffering: { title: 'Загрузка...' },
            captions: { title: 'Субтитры' },
            forwards: { title: '10с вперед' },
            fullscreen: { title: 'Полный экран' },
            pause: { title: 'Пауза' },
            play: { title: 'Воспроизвести' },
            playlist: { title: 'Плейлист' },
            volume: { title: 'Громкость' },
        },
    },
};
